import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { resetVitrineData } from "redux/reducers/criarVitrineReducer";

import VitrineWizardShell from "./components/vitrine-wizard-shell";
import { vitrineB2bEditPath } from "./utils/vitrine-b2b-routes";

export default function CriarVitrine() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const legacyEditId = new URLSearchParams(location.search).get("id");
    if (legacyEditId) {
      history.replace(vitrineB2bEditPath(legacyEditId));
      return;
    }

    dispatch(resetVitrineData());
  }, [dispatch, history, location.search]);

  const legacyEditId = new URLSearchParams(location.search).get("id");
  if (legacyEditId) {
    return null;
  }

  return <VitrineWizardShell mode="create" />;
}
